import React, { useContext, useEffect } from "react";
import { Form as FormAntd, message } from "antd";
import { Layer } from "../../../../component/layer/layer";
import { InventoryGoodsFormBasic } from "./out_stock_goods_form_basic";
import { Button } from "../../../../component/button";
import { OutStockFormStore } from "../../store/out-stock/out_stock_form_store";
import { outStockAction } from "../../action/out-stock/out_stock_action";
import { outStockFormAction } from "../../action/out-stock/out_stock_form_action";
import { useBoolean } from "ahooks";

interface IForm {
    children?: any;
    action: any;
    close: (hasUpdate?: boolean) => void;
    id?: string;
    subId: string;
    method?: string;
    audit: boolean;
    item;
}
export function Form({ close, method, id, subId, item, audit }: IForm) {
    const [form] = FormAntd.useForm();
    const [loading, loadFunc] = useBoolean(false)
    const { state, dispatch } = useContext(OutStockFormStore);

    const action = outStockFormAction;

    useEffect(() => {

        action.init({ state: state, dispatch, id, form, method });

        return () => {

        }
    }, []);

    const title = () => {
        if ("Create" === method) {
            return "新增出库存单";
        }
        else if ("Edit" === method) {
            return "编辑出库存单";
        }
        else {
            return "预览出库存单";
        }
    }

    return (
        <FormAntd form={form}>
            <Layer layerWith={4} >
                <Layer.Title onClick={() => close()}>{title()}</Layer.Title>
                <Layer.Body>
                    <InventoryGoodsFormBasic disabled={!("Create" == method || "Edit" == method)} updateFormField={(field, value = '') => {
                        form.setFieldsValue({
                            [field]: value,
                        });
                    }} />
                </Layer.Body>
                <Layer.Foot borderStyle={title() == '预览出库存单' ? { border: 'none' } : {}}>
                    {
                        ("Create" == method || "Edit" == method) && (
                            <Button type="primary" color="Yellow" style={{ marginRight: "1.25rem" }} onClick={async () => {
                                let formV = await form.validateFields();
                                if(loading){
                                    message.loading('正在提交数据')
                                    return false
                                }
                                let r = false;
                                if ("Create" == method) {
                                    loadFunc.setTrue()
                                    r = await action.addSubmit({ state, status: 2 });
                                    loadFunc.setFalse()
                                } else {
                                    loadFunc.setTrue()
                                    r = await action.updSubmit({ state, status: 2 }, subId);
                                    loadFunc.setFalse()
                                }
                                if (r) {
                                    action.clearTableList({ dispatch });

                                    close(true);
                                }
                            }}>
                                保存并返回
                            </Button>
                        )
                    }
                    {
                        ("Create" == method || "Edit" == method && item.inventoryStatus == 2) && audit && (
                            <Button type="primary" color="Red" onClick={async () => {
                                let formV = await form.validateFields();
                                if(loading){
                                    message.loading('正在提交数据')
                                    return false
                                }
                                let r = false;
                                if ("Create" == method) {
                                    loadFunc.setTrue()
                                    r = await action.addSubmit({ state, status: 1 });
                                    loadFunc.setFalse()
                                } else {
                                    loadFunc.setTrue()
                                    r = await action.updSubmit({ state, status: 1 }, subId);
                                    loadFunc.setFalse()
                                }
                                if (r) {
                                    action.clearTableList({ dispatch });

                                    close(true);
                                }
                            }}>
                                保存并审核
                            </Button>
                        )
                    }
                </Layer.Foot>

            </Layer>
        </FormAntd>
    )
}